// extracted by mini-css-extract-plugin
export default {"overlay":"BG-z","bodyOpen":"CG-z","content":"DG-z","header":"EG-z","close":"FG-z","closeNoHeading":"GG-z"};